import axios from 'axios';

export const fetchMediaService = (conferenceId: string) =>
  axios.get(`/api/conferences/${conferenceId}/mediafiles`);

export const fetchSignedUploadUrlService = (
  conferenceId: string,
  folder: string,
  filename: string,
  type: string
) =>
  axios.get(`/api/conferences/${conferenceId}/upload/${folder}`, {
    params: { filename, type },
  });

export const addMediaService = (conferenceId: string, name: string, filename: string) =>
  axios.post(`/api/conferences/${conferenceId}/media`, { name, filename });

export const updateMediaService = (mediaId: string) => axios.put(`/api/media/${mediaId}/`);

export const uploadToS3 = (url: string, file: any) => {
  return axios.put(url, file);
};